var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 563.33 278.94",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-862.1 -792.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m958.48 923.08a48.86 48.86 0 1 1 97.71-.49z",
    fill: "#fff",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1188.08 808.35a21.46 21.46 0 1 1 -21.45 21.46 21.46 21.46 0 0 1 21.45-21.46z",
    fill: "#0c0c0c",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001.27 826.69a20.38 20.38 0 1 1 -20.37 20.38 20.37 20.37 0 0 1 20.37-20.38z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1182.37 1044.19a9.87 9.87 0 1 1 -9.87 9.87 9.87 9.87 0 0 1 9.87-9.87z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1086.32 905.79a54.06 54.06 0 0 1 -38.34-16 54.6 54.6 0 0 1 17.58-88.92 53.92 53.92 0 0 1 20.74-4.15z",
    fill: "#0c0c0c",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1321.57 840.22a54.14 54.14 0 0 1 -15.81 38.41 54.6 54.6 0 0 1 -89-17.22 53.93 53.93 0 0 1 -4.24-20.73z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1211.08 856.23a59.62 59.62 0 1 1 -119.23.79z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1242.59 926.08a103.75 103.75 0 1 1 -207.49 0z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1245.7 995.46.9-96.9 96.91.9a96.94 96.94 0 0 1 -97.81 96z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1340.45 940.5h85v85a85 85 0 0 1 -85-85z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1340.45 792.36h85v85a85 85 0 0 1 -85-84.95z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1278.19 1006.29a32.5 32.5 0 1 1 -32.49 32.5 32.49 32.49 0 0 1 32.49-32.5z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m963.77 933.8a24.92 24.92 0 1 1 -24.92 24.92 24.91 24.91 0 0 1 24.92-24.92z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.58 852.39a24.92 24.92 0 1 1 -24.91 24.92 24.92 24.92 0 0 1 24.91-24.92z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.88 883.62a32.8 32.8 0 1 1 -32.78 32.8 32.79 32.79 0 0 1 32.78-32.8z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.88 972.21a10.83 10.83 0 1 1 -10.82 10.79 10.83 10.83 0 0 1 10.82-10.79z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.56 995.46a10.83 10.83 0 1 1 -10.82 10.83 10.83 10.83 0 0 1 10.82-10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1218.13 891.73a10.83 10.83 0 1 1 -10.83 10.83 10.82 10.82 0 0 1 10.83-10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1338.38 856.61a10.83 10.83 0 1 1 -10.83 10.83 10.83 10.83 0 0 1 10.83-10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1123.5 829.39a10.83 10.83 0 1 1 -10.83 10.83 10.83 10.83 0 0 1 10.83-10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1021.65 979.55a14.32 14.32 0 1 1 -14.32 14.32 14.32 14.32 0 0 1 14.32-14.32z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1382.93 872.79a33 33 0 1 1 -33 33 33 33 0 0 1 33-33z",
    opacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBg);
export default __webpack_public_path__ + "static/media/pricing_bg.942a235fc60a080dc8254f081a035395.svg";
export { ForwardRef as ReactComponent };